import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-078ec31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-5 mb-0" }
const _hoisted_2 = {
  key: 0,
  class: "fs-6 fst-italic"
}
const _hoisted_3 = { class: "buttons d-flex justify-content-end align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "restart_alt", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-primary ms-2",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "search")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_base_card_header = _resolveComponent("base-card-header")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_SelectBrands = _resolveComponent("SelectBrands")!
  const _component_SelectTrademarks = _resolveComponent("SelectTrademarks")!
  const _component_SelectCategories = _resolveComponent("SelectCategories")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_InputRadioBoolean = _resolveComponent("InputRadioBoolean")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.criteriaUI.getError()
    }, null, 8, ["error"]),
    _createVNode(_component_BaseSpinner, {
      spin: _ctx.criteriaUI.isNotReady()
    }, null, 8, ["spin"]),
    (_ctx.criteriaUI.isReady())
      ? (_openBlock(), _createBlock(_component_dp_form, {
          key: 0,
          as: "form",
          novalidate: "",
          onSubmit: _ctx.submitData
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_base_card, {
              class: _normalizeClass(["criteria", {'is-changed': _ctx.productsCriteriaIsChanged}])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_card_header, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_1, [
                      _createTextVNode(_toDisplayString(_ctx.$t('filters')) + " ", 1),
                      (_ctx.productsCriteriaIsChanged)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(` (${'aangepast'})`), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-icon btn-danger",
                        type: "reset",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearCriteria && _ctx.clearCriteria(...args)), ["prevent"]))
                      }, _hoisted_5),
                      _hoisted_6
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_card_body, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      "model-value": _ctx.cnkCodeSingleValue,
                      "onUpdate:modelValue": _ctx.updateCnkCode,
                      label: _ctx.$t('cnkCode'),
                      name: "filter_cnk_code",
                      class: "mt-1",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["model-value", "onUpdate:modelValue", "label", "errors"]),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.productsCriteria.search_keyword,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productsCriteria.search_keyword) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('keyword'),
                      name: "search_keyword",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"]),
                    _createVNode(_component_SelectBrands, {
                      "selected-brand-codes": _ctx.productsCriteria.filter_labo_code ? [_ctx.productsCriteria.filter_labo_code] : [],
                      "catalog-customer-code": _ctx.catalogCustomerCode,
                      class: _normalizeClass([{'brand-selected': _ctx.productsCriteria.filter_labo_code}, "mb-3"]),
                      "btn-class": "btn btn-icon btn-outline-primary",
                      onAddBrand: _ctx.setLaboCode,
                      onRemoveBrand: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLaboCode(undefined)))
                    }, null, 8, ["selected-brand-codes", "catalog-customer-code", "class", "onAddBrand"]),
                    _createVNode(_component_SelectTrademarks, {
                      "selected-trademark-codes": _ctx.productsCriteria.filter_trademark_code ? [_ctx.productsCriteria.filter_trademark_code] : [],
                      "catalog-customer-code": _ctx.catalogCustomerCode,
                      class: _normalizeClass([{'trademark-selected': _ctx.productsCriteria.filter_trademark_code}, "mb-3"]),
                      "btn-class": "btn btn-icon btn-outline-primary",
                      onAddTrademark: _ctx.setTrademarkCode,
                      onRemoveTrademark: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTrademarkCode(undefined)))
                    }, null, 8, ["selected-trademark-codes", "catalog-customer-code", "class", "onAddTrademark"]),
                    _createVNode(_component_SelectCategories, {
                      "selected-product-categories": _ctx.productsCriteria.filter_category_code ? [_ctx.productsCriteria.filter_category_code] : [],
                      "catalog-customer-code": _ctx.catalogCustomerCode,
                      class: _normalizeClass([{'category-selected': _ctx.productsCriteria.filter_category_code}, "mb-2"]),
                      "btn-class": "btn btn-icon btn-sm btn-outline-primary w-100",
                      "btn-icon": "category",
                      onAddCategory: _ctx.setCategoryCodeDpManaged,
                      onRemoveCategory: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setCategoryCodeDpManaged(undefined)))
                    }, null, 8, ["selected-product-categories", "catalog-customer-code", "class", "onAddCategory"]),
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_products_in_subcategory_expected,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productsCriteria.filter_is_products_in_subcategory_expected) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('subcategories_included'),
                      name: "expect_products_in_subcategory",
                      class: "mb-4",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_custom_sort_weight_available,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((_ctx.productsCriteria.filter_is_custom_sort_weight_available) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('with_custom_sort_available'),
                      name: "filter_is_custom_sort_weight_available",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_custom_name_available,
                      "onUpdate:modelValue": [
                        _cache[7] || (_cache[7] = ($event: any) => ((_ctx.productsCriteria.filter_is_custom_name_available) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('with_custom_name_available'),
                      name: "filter_is_custom_name_available",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_custom_price_available,
                      "onUpdate:modelValue": [
                        _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productsCriteria.filter_is_custom_price_available) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('with_custom_price_available'),
                      name: "filter_is_custom_price_available",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_has_dp_reference_based_price,
                      "onUpdate:modelValue": [
                        _cache[9] || (_cache[9] = ($event: any) => ((_ctx.productsCriteria.filter_has_dp_reference_based_price) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('has_standard_price_source_code_dp_reference_based'),
                      name: "filter_has_dp_reference_based_price",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_has_no_price,
                      "onUpdate:modelValue": [
                        _cache[10] || (_cache[10] = ($event: any) => ((_ctx.productsCriteria.filter_has_no_price) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('has_standard_price_source_code_no_price'),
                      name: "filter_has_no_price",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MINIMAL_STOCK') && _ctx.AuthContext.isDpUser())
                      ? (_openBlock(), _createBlock(_component_InputRadioBoolean, {
                          key: 0,
                          modelValue: _ctx.productsCriteria.filter_has_minimal_stock,
                          "onUpdate:modelValue": [
                            _cache[11] || (_cache[11] = ($event: any) => ((_ctx.productsCriteria.filter_has_minimal_stock) = $event)),
                            _ctx.onCriteriaChanged
                          ],
                          label: _ctx.$t('has_minimal_stock'),
                          name: "filter_has_minimal_stock",
                          "can-clear": "",
                          errors: errors,
                          class: "text-green"
                        }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MAXIMAL_ORDER_AMOUNT') && _ctx.AuthContext.isDpUser())
                      ? (_openBlock(), _createBlock(_component_InputRadioBoolean, {
                          key: 1,
                          modelValue: _ctx.productsCriteria.filter_has_maximum_order_quantity,
                          "onUpdate:modelValue": [
                            _cache[12] || (_cache[12] = ($event: any) => ((_ctx.productsCriteria.filter_has_maximum_order_quantity) = $event)),
                            _ctx.onCriteriaChanged
                          ],
                          label: _ctx.$t('has_maximum_order_quantity'),
                          name: "filter_has_maximum_order_quantity",
                          "can-clear": "",
                          errors: errors,
                          class: "text-green"
                        }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_SW_SYNC'))
                      ? (_openBlock(), _createBlock(_component_InputRadioBoolean, {
                          key: 2,
                          modelValue: _ctx.productsCriteria.filter_has_price_from_software_sync,
                          "onUpdate:modelValue": [
                            _cache[13] || (_cache[13] = ($event: any) => ((_ctx.productsCriteria.filter_has_price_from_software_sync) = $event)),
                            _ctx.onCriteriaChanged
                          ],
                          label: _ctx.$t('has_price_from_software_sync'),
                          name: "filter_has_price_from_software_sync",
                          "can-clear": "",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.AbilityContext.isAuthorizedForFeature('BACK_IN_STOCK_NOTIFICATION') && _ctx.AuthContext.isDpUser())
                      ? (_openBlock(), _createBlock(_component_InputRadioBoolean, {
                          key: 3,
                          modelValue: _ctx.productsCriteria.filter_has_open_stock_notification_request,
                          "onUpdate:modelValue": [
                            _cache[14] || (_cache[14] = ($event: any) => ((_ctx.productsCriteria.filter_has_open_stock_notification_request) = $event)),
                            _ctx.onCriteriaChanged
                          ],
                          label: _ctx.$t('has_open_stock_notification_request'),
                          name: "filter_has_open_stock_notification_request",
                          "can-clear": "",
                          errors: errors,
                          class: "text-green"
                        }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_without_cnk,
                      "onUpdate:modelValue": [
                        _cache[15] || (_cache[15] = ($event: any) => ((_ctx.productsCriteria.filter_is_without_cnk) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('is_without_cnk'),
                      name: "filter_is_without_cnk",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_has_own_cnk,
                      "onUpdate:modelValue": [
                        _cache[16] || (_cache[16] = ($event: any) => ((_ctx.productsCriteria.filter_has_own_cnk) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('has_own_cnk'),
                      name: "filter_has_own_cnk",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_own_product,
                      "onUpdate:modelValue": [
                        _cache[17] || (_cache[17] = ($event: any) => ((_ctx.productsCriteria.filter_is_own_product) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('is_own_product'),
                      name: "filter_is_own_product",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}